<template>
  <v-dialog
    width="auto"
    title="Preview QR Code"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    @closed="onClosed"
    @open="onOpen"
    :z-index="20001"
  >
    <div class="qrcode" id="qrcode">
      <el-image :src="qrcodeUrl" v-loading="loading">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
  </v-dialog>
</template>

<script>
import qrcode from "qrcode";
export default {
  name: "QRCodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: String,
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      qrcodeUrl: "",
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClosed() {
      this.qrcodeUrl = "";
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    onOpen() {
      if (this.data) {
        this.loading = true;
        /*  this.axios
          .get("/se/qrCode", {
            params: {
              seId: this.data.SEID,
            },
          })
          .then(({ code, data }) => {
            if (code === 200) {
              this.qrcodeUrl = data;
            } else {
              this.$message.error("Get QR Code failure");
            }
            this.loading = false;
          }); */
        let opts = {
          errorCorrectionLevel: "H",
          type: "image/jpeg",
        };

        qrcode.toDataURL(this.data, opts, (err, url) => {
          if (err) throw err;
          this.qrcodeUrl = url;
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-image {
  width: 200px;
  height: 200px;
}
::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
.qrcode {
  position: relative;
  padding: 30px;
  h3 {
    color: #000;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
